<template>
  <b-modal
      size="md"
      hide-footer
      v-model="show"
      title="Edição da Configuração do Sistema"
      @hidden="cancelar"
  >
    <b-card>
      <b-row>
        <b-col cols="12">
          <div><span class="font-weight-bold">Configuração:</span> {{ this.configuracao.tituloPropriedade }}</div>
        </b-col>
      </b-row>
    </b-card>

    <b-form @submit.prevent="salvar">
      <b-form-group>
        <LgFinderPageAlmoxarifado
            :podeApagar="false"
            id="finderAlmoxarifadoCentralModal"
            v-model="form.almoxarifado"
            label="Almoxarifado:"
            required
            @onselect="handleSelectAlmoxarifado"
        />
      </b-form-group>
      <b-form-row class="d-flex justify-content-center">
        <b-button type="submit" size="sm" pill variant="success">
          <b-icon icon="check-circle" />
        </b-button>
        <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
          <b-icon icon="x-circle" />
        </b-button>
      </b-form-row>
    </b-form>
  </b-modal>
</template>

<script>
import LgFinderPageAlmoxarifado from "@/components/Finders/LgFinderPageAlmoxarifado.vue";
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";

export default {
  components: {
    LgFinderPageAlmoxarifado,
  },
  props: {
    configuracao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      form: {
        almoxarifado: null,
      },
    };
  },
  methods: {
    handleSelectAlmoxarifado(almoxarifado) {
      this.form.almoxarifado = almoxarifado;
    },
    async salvar() {
      if (!this.form.almoxarifado) {
        this.$bvToast.toast("Selecione um almoxarifado", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return;
      }

      const payload = {
        id: this.configuracao.id,
        valorPropriedade: this.form.almoxarifado.id.toString(),
      };

      try {
        await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
        this.$emit("salvo");
        await Swal.fire({
          title: "Sucesso",
          text: "Configuração salva com sucesso!",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        this.$bvToast.toast("Erro ao salvar configuração", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      }
    },
    cancelar() {
      this.$emit("close");
    },
    loadAlmoxarifado() {
      this.form.almoxarifado = {
        id: parseInt(this.configuracao.valorPropriedade),
        descricao: this.configuracao.valorPropriedadeLabel,
      }
    },
  },
  async mounted() {
    this.loadAlmoxarifado();
  },
};
</script>
